import React, { useEffect, useState, Fragment } from 'react';
import { Clock, Users } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-red-500 text-white px-3 sm:px-5 py-4" data-id="element-121">
      <div className="flex items-center justify-center gap-2 font-black text-sm uppercase tracking-wide mb-3" data-id="element-122">
        <Clock className="w-4 h-4 animate-pulse flex-shrink-0" data-id="element-123" />
        <span data-id="element-124">La oferta termina en</span>
      </div>

      <div className="flex justify-center items-start gap-1.5 mb-4" data-id="element-125">
        {[{
        v: timeLeft.hours,
        l: 'Horas'
      }, {
        v: timeLeft.minutes,
        l: 'Min'
      }, {
        v: timeLeft.seconds,
        l: 'Seg'
      }].map((unit, i) => <Fragment key={unit.l} data-id="element-126">
            <div className="bg-white/15 backdrop-blur rounded-lg flex-1 min-w-0 max-w-[68px] py-1.5" data-id="element-127">
              <div className="text-2xl font-black tabular-nums leading-none" data-id="element-128">
                {formatTime(unit.v)}
              </div>
              <div className="text-[9px] uppercase font-bold opacity-80 mt-1" data-id="element-129">
                {unit.l}
              </div>
            </div>
            {i < 2 && <div className="text-xl font-black pt-1.5 flex-shrink-0" data-id="element-130">:</div>}
          </Fragment>)}
      </div>

      <div className="space-y-1.5" data-id="element-131">
        <div className="flex justify-between text-xs font-bold" data-id="element-132">
          <span className="flex items-center gap-1" data-id="element-133">
            <Users className="w-3.5 h-3.5" data-id="element-134" /> Cupos disponibles
          </span>
          <span data-id="element-135">570 / 1000</span>
        </div>
        <div className="w-full bg-white/25 rounded-full h-2" data-id="element-136">
          <div className="bg-white h-2 rounded-full transition-all" style={{
          width: '57%'
        }} data-id="element-137"></div>
        </div>
      </div>
    </div>;
}